import Vue from 'vue'
Vue.config.productionTip = false
export const bus = new Vue()
